import { render } from "./CertificateTemplates.vue?vue&type=template&id=6c595368"
import script from "./CertificateTemplates.vue?vue&type=script&lang=js"
export * from "./CertificateTemplates.vue?vue&type=script&lang=js"

import "./CertificateTemplates.vue?vue&type=style&index=0&id=6c595368&lang=css"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__